// import * as types from '../mutation-types'

const state = {
  bookIns: [],
  bookDts: [],
  bookIn: {}
}

const mutations = {
  setLoadedbookIns (state, payload) {
    state.bookIns = payload
  },
  setLoadedbookDts (state, payload) {
    state.bookDts = payload
  }
}

const actions = {
  loadbookIns ({commit}, playload) {
    commit('setLoadedMeetups', playload)
  }
}

const getters = {
  loadedOutsideBooks (state) {
    return state.bookIns
    .sort((bookA, bookB) => {
      return bookB.ID > bookA.ID
    })
  },
  featuredBooks (state, getters) {
    return getters.loadedOutsideBooks.slice(0, 5)
  },
  loadedOutsideBook (state) {
    return (bookID) => {
      return state.bookIns.find((books) => {
        return books.ID.toString() === bookID
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
